export default __webpack_public_path__ + "static/media/Screenshot_1.98981f21.png";